import { Coins } from 'lucide-react';

/** Public-facing one-line CyberKids disclosure. No internal split shown. */
export default function PublicLegacyDisclosure() {
  return (
    <section data-testid="public-legacy-disclosure" className="sov-border bg-gradient-to-br from-[#0A0A0A] via-[#0A0A0A] to-[#D4AF37]/10 p-10 md:p-14 text-center">
      <Coins size={26} strokeWidth={1.25} className="text-[#D4AF37] mx-auto mb-5" />
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-4">Legacy Disclosure</div>
      <h3 className="text-2xl md:text-3xl font-extralight max-w-3xl mx-auto leading-[1.3]">
        <span className="font-display italic text-[#D4AF37]">10%</span> of all revenue is vaulted to{' '}
        <span className="font-display italic text-[#D4AF37]">CyberKids Academy.</span>
      </h3>
      <div className="mt-6 text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] flex items-center justify-center gap-3">
        <span className="w-6 h-px bg-[#D4AF37]" />
        Empowered by EIGOO INC
        <span className="w-6 h-px bg-[#D4AF37]" />
      </div>
    </section>
  );
}
